import {
  NEUTRAL,
  SUCCESS,
  ERROR,
  WARNING,
  TERTIARY,
  BACKGROUND,
  TEXT,
  PRIMARY_LEARN,
  PRIMARY_SRICHANTANYA,
  SECONDARY_SRICHANTANYA,
  OVERLAY,
  TEST,
  BUTTON_SUCCESS,
} from "../../primitives/colors";
import type { ThemeColors } from "../../semantic/colors";
import { buildSubjectColors } from "./subjectColors";

export const sriChaitanyaColors: ThemeColors = {
  primary: PRIMARY_SRICHANTANYA,
  secondary: SECONDARY_SRICHANTANYA,
  tertiary: TERTIARY,
  neutral: NEUTRAL,
  success: SUCCESS,
  error: ERROR,
  warning: WARNING,
  text: TEXT,
  background: BACKGROUND,
  subject: buildSubjectColors({
    primary: PRIMARY_LEARN,
    warning: WARNING,
    success: SUCCESS,
    error: ERROR,
    tertiary: TERTIARY,
  }),
  overlay: OVERLAY,
  test: TEST,
  buttonSuccess: BUTTON_SUCCESS,
};
